/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixture_WhenInputs */

const th_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาเริ่ม`)
};

const en_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start time`)
};

const ja_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時刻`)
};

const zh_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时间`)
};

const es_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de inicio`)
};

const pt_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horário de início`)
};

const id_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu mulai`)
};

const fr_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de début`)
};

const tl_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oras ng simula`)
};

const vi_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ bắt đầu`)
};

const ko_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작 시각`)
};

const de_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startzeit`)
};

const ru_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время начала`)
};

const tr_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlama saati`)
};

const it_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora di inizio`)
};

const pl_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godzina rozpoczęcia`)
};

const uk_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час початку`)
};

const hi_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आरंभ का समय`)
};

const ar_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت البدء`)
};

const ms_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu mula`)
};

const bn_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরুর সময়`)
};

const zh_tw2_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間`)
};

const zh_hk2_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間`)
};

const ur_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آغاز کا وقت`)
};

const fa_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمان آغاز`)
};

const sw_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa ya kuanza`)
};

const nl_fixture_when = /** @type {(inputs: Fixture_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanvangstijd`)
};

/**
* | output |
* | --- |
* | "Start time" |
*
* @param {Fixture_WhenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const fixture_when = /** @type {((inputs?: Fixture_WhenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixture_WhenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_fixture_when(inputs)
	if (locale === "ja") return ja_fixture_when(inputs)
	if (locale === "zh") return zh_fixture_when(inputs)
	if (locale === "es") return es_fixture_when(inputs)
	if (locale === "pt") return pt_fixture_when(inputs)
	if (locale === "id") return id_fixture_when(inputs)
	if (locale === "fr") return fr_fixture_when(inputs)
	if (locale === "tl") return tl_fixture_when(inputs)
	if (locale === "vi") return vi_fixture_when(inputs)
	if (locale === "ko") return ko_fixture_when(inputs)
	if (locale === "de") return de_fixture_when(inputs)
	if (locale === "ru") return ru_fixture_when(inputs)
	if (locale === "tr") return tr_fixture_when(inputs)
	if (locale === "it") return it_fixture_when(inputs)
	if (locale === "pl") return pl_fixture_when(inputs)
	if (locale === "uk") return uk_fixture_when(inputs)
	if (locale === "hi") return hi_fixture_when(inputs)
	if (locale === "ar") return ar_fixture_when(inputs)
	if (locale === "ms") return ms_fixture_when(inputs)
	if (locale === "bn") return bn_fixture_when(inputs)
	if (locale === "zh-TW") return zh_tw2_fixture_when(inputs)
	if (locale === "zh-HK") return zh_hk2_fixture_when(inputs)
	if (locale === "ur") return ur_fixture_when(inputs)
	if (locale === "fa") return fa_fixture_when(inputs)
	if (locale === "sw") return sw_fixture_when(inputs)
	if (locale === "nl") return nl_fixture_when(inputs)
	return en_fixture_when(inputs)
});